module.exports = __webpack_public_path__ + "static/img/hardDR2.6e426a99.png";